import Vue from 'vue';
import Router from 'vue-router';
import CadastroPessoas from './views/administrator/pessoa/List.vue'
import CadastroEmpresa from './views/administrator/empresa/List.vue'
import Obras from './views/administrator/obra/List.vue'
import Boleto from './views/administrator/boleto/List.vue'
import BoletoNaoPago from './views/administrator/listadeboletos/List.vue'
import Entrada from './views/administrator/entrada/List.vue'
import Balanco from './views/administrator/balanco/List.vue'
import Valores from './views/administrator/valores/List.vue'
import Saida from './views/administrator/saida/List.vue'
import Materiais from './views/administrator/controle_materiais/List.vue'
import Home from './components/Home.vue'
import user from '@/utils/user.json';

Vue.use(Router);

const router = new Router({
  base: process.env.BASE_URL,
  mode: 'hash',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () =>
        import(
          /* webpackChunkName: "login" */ '@/views/authentication/Login.vue'
        ),
      meta: {
        isPublic: true
      }
    },
    {
      path: '/home',
      name: 'Sistema de gestão - Construtora MK & representações',
      component: Home,
      meta: {
        titulo: 'home',
        role: ['admin','compras','financeiro','rh']
      }
    },
    {
      path: '/cadastrodeboleto',
      name: 'Sistema de gestão - Construtora MK & representações',
      component: Boleto,
      meta: {
        titulo: 'cadastrodeboleto',
        role: ['admin','financeiro','compras']
      }
    },
    {
      path: '/materiais',
      name: 'Sistema de gestão - Construtora MK & representações',
      component: Materiais,
      meta: {
        titulo: 'materiais',
        role: ['admin','financeiro','compras']
      }
    },
    {
      path: '/cadastrodevalores',
      name: 'Sistema de gestão - Construtora MK & representações',
      component: Valores,
      meta: {
        titulo: 'cadastrodevalores',
        role: ['admin','financeiro']
      }
    },
    {
      path: '/listadeboletos',
      name: 'Sistema de gestão - Construtora MK & representações',
      component: BoletoNaoPago,
      meta: {
        titulo: 'listadeboletos',
        role: ['admin','compras']
      }
    },
    {
      path: '/cadastrodeobras',
      name: 'Sistema de gestão - Construtora MK & representações',
      component: Obras,
      meta: {
        titulo: 'cadastrodeobras',
        role: ['admin','compras']
      }
    },
    {
      path: '/cadastrodepessoas',
      name: 'Sistema de gestão - Construtora MK & representações',
      component: CadastroPessoas,
      meta: {
        titulo: 'cadastrodepessoas',
        role: ['admin','compras','rh']
      }
    },
    {
      path: '/cadastrodeempresas',
      name: 'Sistema de gestão - Construtora MK & representações',
      component: CadastroEmpresa,
      meta: {
        titulo: 'cadastrodeempresas',
        role: ['admin','compras']
      }

    },
    {
      path: '/saida',
      name: 'Sistema de gestão - Construtora MK & representações',
     component: Saida,
      meta: {
        titulo: 'saida',
        role: ['admin','compras']
      }

    },
    {
      path: '/entrada',
      name: 'Sistema de gestão - Construtora MK & representações',
      component: Entrada,
      meta: {
        titulo: 'entrada',
        role: ['admin']
      }
    },
    {
      path: '/balanco',
      name: 'Sistema de gestão - Construtora MK & representações',
      component: Balanco,
      meta: {
        titulo: 'balanco',
        role: ['admin']
      }
    },
    {
      path: '/',
      redirect: '/login',
      name: 'Login',
      meta: {
        isPublic: true,
        role: ['admin','compras']
      }
    }
  ],
});

router.beforeEach((to, from, next) => {

    if(to.meta.isPublic){
      next();
      return;
    }

    const email = localStorage.getItem("email_logged");
    const userLogged = user.find((item)=> item.email == email);
    if (userLogged) {
      if (to.meta.role && !to.meta.role.find((item) => item == userLogged.role)) {
        // Usuário não tem permissão para acessar a rota
        next({ name: 'Home' }); // redirecionar para a página inicial ou outra página de acesso restrito
      } else {
        next(); // Usuário tem permissão para acessar a rota
      }
    } else {
      // Usuário não está autenticado
      next({ path: '/login' }); // redirecionar para a página de login
    }
});

export default router;
